import ApiService from '@/services/api.service';

const ScreensService = {
    getAll(parameter) {
        const requestData = {
            method: 'get',
            url: '/Screens/',
            params: {
                SearchCriteria: parameter.SearchCriteria,
                PageSize: parameter.PageSize,
                PageNumber: parameter.PageNumber
            }
        };
        return ApiService.customRequest(requestData);
    },
    Get(Id) {
        return ApiService.get(`/Screens/${Id}`);
    }
};

export default ScreensService;
